import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";
import "@fortawesome/fontawesome-free/css/brands.min.css";
import Cookies from "js-cookie";
import { enableMapSet } from "immer";
import { TestTokenProvider, TestUser } from "./dev";
import { useEffect } from "react";
import { pwaAuthService, PWAUser } from "./services/pwaAuthService";
import { pwaService } from "./services/pwaService";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// THIS WILL SET COOKIES FOR TOKEN FOR DEVELOPMENT ONLY
// if (process.env.REACT_APP_ENV === "dev") {
//     const cookieValue = TestTokenProvider(TestUser.ARYA);
//     Cookies.set("U_EVAL_VALUE", cookieValue);
//     localStorage.setItem("U_EVAL_VALUE", cookieValue);
// }
// Initialize PWA services
const initializePWA = async () => {
    try {
        const isDevLikeEnv =
            process.env.REACT_APP_ENV === "local" || process.env.NODE_ENV === "development";

        if (isDevLikeEnv) {
            await pwaService.unregisterServiceWorkers();
            console.log("PWA service worker disabled for local/development");
            return;
        }

        // Register service worker
        await pwaService.registerServiceWorker();
        console.log("PWA services initialized");
    } catch (error) {
        console.error("Failed to initialize PWA services:", error);
    }
};

// Enhanced authentication logic with PWA support
const handleAuthentication = async () => {
    // Initialize PWA first
    await initializePWA();

    // Check for PWA auto-login first
    try {
        const pwaUser = await pwaAuthService.attemptAutoLogin();
        if (pwaUser) {
            console.log("PWA auto-login successful");
            enableMapSet();
            renderApp();
            return;
        }
    } catch (error) {
        console.error("PWA auto-login failed:", error);
    }

    // Fallback to existing authentication logic
    if (process.env.REACT_APP_ENV === "local") {
        // const cookieValue = TestTokenProvider(TestUser.HYPER);
        // const cookieValue = TestTokenProvider(TestUser.NYX);
        // const cookieValue = TestTokenProvider(TestUser.QA_RAHUL);
        // const cookieValue = TestTokenProvider(TestUser.ARVIND_MANAGER);
        // const cookieValue = TestTokenProvider(TestUser.QA_BHAVESH);
        // const cookieValue = TestTokenProvider(TestUser.QA_NEHA);
        // const cookieValue = TestTokenProvider(TestUser.QA_APPROVER);
        // const cookieValue = TestTokenProvider(TestUser.LEVELONE_EMPONE);
        // const cookieValue = TestTokenProvider(TestUser.PACE_DANIEL);
        // const cookieValue = TestTokenProvider(TestUser.PACE_EDUARD);
        // const cookieValue = TestTokenProvider(TestUser.PACE_SUPERADMIN);
        // const cookieValue = TestTokenProvider(TestUser.Pariswork);
        const cookieValue = TestTokenProvider(TestUser.PACE_DANIEL);
        // const cookieValue = TestTokenProvider(TestUser.PACE_YURI);
        // const cookieValue = TestTokenProvider(TestUser.PACE_SHAWN);
        // const cookieValue = TestTokenProvider(TestUser.PACE_EDUARD);
        // const cookieValue = TestTokenProvider(TestUser.PACE_DAVID);  
        // const cookieValue = TestTokenProvider(TestUser.PACE_MARTIN);
        // const cookieValue = TestTokenProvider(TestUser.PACE_MILOS);
        // const cookieValue = TestTokenProvider(TestUser.PACE_NIKOLA);
        
        // const cookieValue = TestTokenProvider(TestUser.QALAYFORD);

        // const cookieValue = TestTokenProvider(TestUser.AGNI);
        // const cookieValue = TestTokenProvider(TestUser.ARYA);
        // const cookieValue = TestTokenProvider(TestUser.TEJAS);
        // const cookieValue = TestTokenProvider(TestUser.Melhem);
        // const cookieValue = TestTokenProvider(TestUser.CustomRule);
        Cookies.set("U_EVAL_VALUE", cookieValue);
        localStorage.setItem("U_EVAL_VALUE", cookieValue);
    }

    // Get token from localStorage or Cookies
    // first check in localStorage, if not found, check in Cookies
    let userToken = localStorage.getItem("U_EVAL_VALUE");

    if (!userToken) {
        userToken = Cookies.get("U_EVAL_VALUE") || localStorage.getItem("U_EVAL_VALUE");
    }

    if (!userToken) {
        const redirectUrl = `${process.env.REACT_APP_PHP_FRONTEND_URL}/login/loginform/`;
        window.location.href = redirectUrl;
    } else {
        enableMapSet();
        renderApp();
    }
};

const renderApp = () => {
    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );

    reportWebVitals();
};

// Start authentication flow
handleAuthentication();
